import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../features/auth/authSlice';
import { useGetMyPermissionsQuery } from '../api/endpoints/permissionManagement';

const SCOPE_ALL = 4;

// Yetki kodu bazlı kontrol (Identity /v1/permission/me). Rol bazlı kontroller için usePermissions.
export const usePermissionGrants = () => {
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const { data, isError } = useGetMyPermissionsQuery(undefined, { skip: !isAuthenticated });

    return useMemo(() => {
        const scopes = new Map((data?.permissions || []).map((p) => [p.code, p.scope]));
        const isAdmin = !!data?.isAdmin;
        const has = (code) => isAdmin || scopes.has(code);
        return {
            // Hata = yüklendi ama yetki yok; geçiş döneminde orLegacy devreye girer
            isLoaded: !!data || isError,
            // /me başarılı döndü mü (uç yoksa veya hata verirse false)
            isAvailable: !!data && !isError,
            isAdmin,
            has,
            hasAny: (codes = []) => codes.some(has),
            scopeOf: (code) => (isAdmin ? SCOPE_ALL : scopes.get(code) ?? null),
            effectiveRole: (module) => data?.effectiveRoles?.[module] ?? null
        };
    }, [data, isError]);
};
